var React = require('react');

function List (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"th-list","d":"M34.5,245.3h214.5c6.2,0,11.1-5,11.1-11.1v-37c0-6.2-5-11.1-11.1-11.1H34.5c-6.2,0-11.1,5-11.1,11.1v37\n\tC23.4,240.3,28.4,245.3,34.5,245.3L34.5,245.3z M23.4,49.2v37c0,6.2,5,11.1,11.1,11.1h214.5c6.2,0,11.1-5,11.1-11.1v-37\n\tc0-6.2-5-11.1-11.1-11.1H34.5C28.4,38.2,23.4,43.2,23.4,49.2z M34.5,171.3h214.5c6.2,0,11.1-5,11.1-11.1v-37c0-6.2-5-11.1-11.1-11.1\n\tH34.5c-6.2,0-11.1,5-11.1,11.1v37C23.4,166.4,28.4,171.3,34.5,171.3L34.5,171.3z"}));
}

List.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 283.5 283.5","style":{"enableBackground":"new 0 0 283.5 283.5"},"xmlSpace":"preserve"};

module.exports = List;

List.default = List;
